"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deliveryGroupIdDpdToCode = void 0;
const box_1 = require("./box");
const deliveryGroupIdDpdToCode = (deliveryGroupId) => {
    const key = Object.keys(box_1.boxAI).find(key => box_1.boxAI[key] === 'deliveryGroupId');
    return `(${key})${deliveryGroupId}#`;
};
exports.deliveryGroupIdDpdToCode = deliveryGroupIdDpdToCode;
//# sourceMappingURL=deliveryGroup.js.map